export const SHOW_ERROR_MSG = 'SHOW_ERROR_MSG';
export const SHOW_SUCCESS_MSG = 'SHOW_SUCCESS_MSG';
export const SHOW_WARNING_MSG = 'SHOW_WARNING_MSG';
export const SHOW_INFO_MSG = 'SHOW_INFO_MSG';

export const CLEAN_FORM = 'CLEAN_FORM';
